import React from 'react';
import PropTypes from 'prop-types';
import { isProduction } from '../services/environment/EnvironmentService';
import { getUrlFor } from '../data/NavigationItems';

import './PlaceholderPage.scss';

const PlaceholderPageComponent = ({ name }) => {
  if (isProduction()) {
    // Redirect to M4B page instead of serving a blank React App Placeholder page.
    // E.G. going to /mbs/people would serve a blank page as it would route to the SPA
    // If it's production we will redirect them to the right M4B page.
    window.location.assign(getUrlFor(name));
  }
  return (
    <div className="placeholder-page">
      <h1>
        Placeholder page for
        {name}
      </h1>
    </div>
  );
};

PlaceholderPageComponent.propTypes = {
  name: PropTypes.string.isRequired,
};

PlaceholderPageComponent.displayName = 'PlaceholderPage';

export default PlaceholderPageComponent;
